import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { useDesignColors } from '../../hooks/useDesignColors';

interface FeatureRestrictionModalProps {
  isOpen: boolean;
  onClose: () => void;
  feature: string;
}

export function FeatureRestrictionModal({ isOpen, onClose, feature }: FeatureRestrictionModalProps) {
  const navigate = useNavigate();
  const { colors } = useDesignColors();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div 
        className="max-w-md w-full rounded-xl p-6 relative"
        style={{
          background: `linear-gradient(135deg, ${colors.gradientStart}10, ${colors.gradientEnd}10)`,
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="mb-6">
          <h3 className="text-xl font-semibold text-white mb-2">
            Premium feature
          </h3>
          <p className="text-gray-300">
            {feature} is not available with your Starter subscription. Upgrade to the Professional subscription to access all premium features.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 rounded-lg bg-white/5 text-gray-300 hover:bg-white/10 transition-colors"
          >
            Later
          </button>
          <button
            onClick={() => {
              onClose();
              navigate('/pricing');
            }}
            className="flex-1 px-4 py-2 rounded-lg text-white transition-all"
            style={{
              background: `linear-gradient(135deg, ${colors.gradientStart}, ${colors.gradientEnd})`,
            }}
          >
            View pricing
          </button>
        </div>
      </div>
    </div>
  );
}